import Env from '../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import revealStep0 from '../fx/revealStep0'
import revealStep2 from '../fx/revealStep2'
import revealStep3 from '../fx/revealStep3'
import revealStep4 from '../fx/revealStep4'
import revealStep5 from '../fx/revealStep5'
import revealPart2 from '../fx/revealPart2'
import revealPart2Alt from '../fx/revealPart2Alt'

export default class Storytelling
{
  constructor()
  {
    this.DOM = {}
    this.DOM.stepsA = []
    this.DOM.storyA = document.querySelectorAll('.jsStoryA')
    //
    this.listeners = []
    //
    this.cbs = []
    this.cbs['revealStep0'] = new revealStep0()
    this.cbs['revealStep2'] = new revealStep2()
    this.cbs['revealStep3'] = new revealStep3()
    this.cbs['revealStep4'] = new revealStep4()
    this.cbs['revealStep5'] = new revealStep5()
    this.cbs['revealStep7'] = new revealPart2(document.querySelector('.story7'))
    this.cbs['revealStep8'] = new revealPart2(document.querySelector('.story8'))
    this.cbs['revealStep9'] = new revealPart2(document.querySelector('.story9'))
    this.cbs['revealStep10'] = new revealPart2Alt(document.querySelector('.story10'))
  }

  destroy()
  {
    for(let listener of this.listeners) {
      listener.kill(false)
    }
    this.listeners = []

    for(let story of this.DOM.storyA) {
      story.classList.remove('is-enabled')
      console.log('remi');
    }

    this.cbs['revealStep0'].destroy()
    this.cbs['revealStep2'].destroy()
    this.cbs['revealStep3'].destroy()
    this.cbs['revealStep4'].destroy()
    this.cbs['revealStep5'].destroy()
    this.cbs['revealStep7'].destroy()
    this.cbs['revealStep8'].destroy()
    this.cbs['revealStep9'].destroy()
    this.cbs['revealStep10'].destroy()
  }

  revealCanvas()
  {
    for(const reference of this.DOM.stepsA) {
      const getStoryNumber = reference.getAttribute('data-step')

      const getStoryElement = this.DOM.storyA[getStoryNumber]
      if(getStoryElement != null) {
        const getFxFn = getStoryElement.getAttribute('data-fx')
        const offsetStart = (getStoryElement.getAttribute('data-start') != null)?getStoryElement.getAttribute('data-start'):'top bottom';
        const offsetEnd = (getStoryElement.getAttribute('data-end') != null)?getStoryElement.getAttribute('data-end'):'bottom 110%';
        // let markers = (getStoryNumber == 2)?true:false;
        let markers = false;
        const instance = ScrollTrigger.create({
          trigger:reference,
          start:offsetStart,
          end:offsetEnd,
          markers:markers,
          onEnter:()=>{
            getStoryElement.classList.add('is-enabled')
            if(typeof this.cbs[getFxFn] != 'undefined') {
              this.cbs[getFxFn].play()
            }
          },
          onEnterBack:()=>{
            getStoryElement.classList.add('is-enabled')
            if(typeof this.cbs[getFxFn] != 'undefined') {
              this.cbs[getFxFn].play()
            }
          },
          onLeave:()=>{
            if(typeof this.cbs[getFxFn] != 'undefined') {
              this.cbs[getFxFn].leave(null,()=>{
                getStoryElement.classList.remove('is-enabled')
              })
            } else {
              getStoryElement.classList.remove('is-enabled')
            }
          },
          onLeaveBack:()=>{
            getStoryElement.classList.remove('is-enabled')
            if(typeof this.cbs[getFxFn] != 'undefined') {
              this.cbs[getFxFn].leave(null,()=>{
                getStoryElement.classList.remove('is-enabled')
              })
            } else {
              getStoryElement.classList.remove('is-enabled')
            }
          }
        })
        this.listeners.push(instance)

        // Skin White
        if(getStoryNumber == 6) {
          const triggerWhiteIn = ScrollTrigger.create({
            trigger:reference,
            start:'top top',
            end:'bottom top',
            onEnter:()=>{
              Env.$html.classList.add('ui--isWhite')
            },
            onLeaveBack:()=>{
              Env.$html.classList.remove('ui--isWhite')
            }
          })
          this.listeners.push(triggerWhiteIn)
        }

        // Exit Skin White
        if(getStoryNumber == 10) {
          const triggerWhiteOut = ScrollTrigger.create({
            trigger:reference,
            start:'top bottom',
            end:'bottom top',
            onEnterBack:()=>{
              Env.$html.classList.add('ui--isWhite')
              Env.$html.classList.remove('logo-minimized')
            },
            onLeave:()=>{
              Env.$html.classList.remove('ui--isWhite')
              Env.$html.classList.add('logo-minimized')
            }
          })
          this.listeners.push(triggerWhiteOut)
        }


      }

    }
  }

  updateDOM(view)
  {
    this.DOM.stepsA = view.querySelectorAll('.jsStepA')
    this.setup()
  }

  setup()
  {
    this.revealCanvas()
  }
}
